<template>
    <editor-sidebar class="properties-text-compare" has-tabs visible>
        <template #header>
            <b-btn variant="light" class="mr-2" @click="cancel" :title="'Cancel|Annuler'|tr">
                <i class="fas fa-close"/>
            </b-btn>
            <h4 class="sidebar-title">{{ tr(title) }}</h4>
        </template>

        <b-tabs class="tabs-pills">
            <b-tab title="Comparison">
                <sidebar-group :title="tr(`${comparison.suggestions.length} suggestions`)">
                    <b-form-group :label="tr(`Display|Afficher`)">
                        <b-select v-model="$store.state.comparison.display">
                            <option value="before">Before</option>
                            <option value="compare">Comparison</option>
                            <option value="after">After</option>
                        </b-select>
                    </b-form-group>

                    <b-form-group label="Progression" class="m-2">
                        <template #label>
                            <span v-tr>Progression</span>
                            <span class="float-right">
                                {{completed.length}} / {{comparison.suggestions.length}}
                            </span>
                        </template>
                        <b-progress>
                            <b-progress-bar size="lg" variant="primary" :value="completed.length / comparison.suggestions.length * 100">
                                {{completed.length / comparison.suggestions.length|percentage}}
                            </b-progress-bar>
                        </b-progress>
                    </b-form-group>

                    <b-form-group :label="tr(`Status`)">
                        <b-list-group>
                            <b-list-group-item v-for="stat in stats.status" :key="`i-${stat.status}`">
                                <span class="label">{{stat.status}}</span>
                                <span class="float-right f-500 value">{{stat.count}}</span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-form-group>

                    <b-form-group>
                        <b-btn variant="success" @click="applyAllSuggestions" block>
                            <i class="fas fa-edit mr-1"/>
                            <span v-tr>Apply all remaining changes|Appliquer tous les changements restants</span>
                        </b-btn>
                    </b-form-group>

                    <b-form-group>
                        <b-btn variant="white" @click="cancel" block>
                            <span v-tr>End modifications|Terminer les modifications</span>
                        </b-btn>
                    </b-form-group>
                </sidebar-group>
            </b-tab>
        </b-tabs>
    </editor-sidebar>
</template>

<script>

// properties-text-compare #hot-reload-debug
import EditorSidebar from "@/layout/editor-sidebar.vue";
import SidebarGroup from "@components/editor/properties/components/sidebar-group.vue";

export default {
    name: `properties-text-compare`,
    components: {SidebarGroup, EditorSidebar},
    props: {
        visible: {type: Boolean},
        title: {type: String, default: `Compare Text|Outils de comparaison`}
    },
    data() {
        return {
        }
    },
    computed: {
        comparison() {
            return this.$store.state.comparison;
        },
        textDiffs() {
            return this.$store.state.comparison.suggestions;
        },
        ignored() {
            return this.textDiffs.filter(s => s.status === `ignored`);
        },
        applied() {
            return this.textDiffs.filter(s => s.status === `applied` || s.status === `identical`);
        },
        completed() {
            return this.textDiffs.filter(s => s.status !== `different`);
        },
        stats() {
            let stats = {
                status: {}
            };
            for (let textDiff of this.textDiffs) {
                if (stats.status[textDiff.status]) {
                    stats.status[textDiff.status].count++;
                } else {
                    stats.status[textDiff.status] = {
                        status: textDiff.status,
                        count: 1
                    }
                }
            }
            return stats;
        }
    },
    methods: {
        cancel() {
            this.$emit(`close`);
            this.$store.state.comparison.enabled = false;
        },
        applyAllSuggestions() {
            for (let textDiff of this.textDiffs) {
                if (!textDiff.component || textDiff.status !== `different`)
                    continue;

                this.$set(textDiff.component.newText, this.displayLanguage, textDiff.suggestion);
                this.$set(textDiff.component.text, this.displayLanguage, textDiff.suggestion);
                this.$set(textDiff, `status`, `applied`);
            }
            this.$store.commit(`updateCache`);

            // this.$store.state.comparison.enabled = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.hint {
    float: right;
    opacity: 0.75;
}
</style>
